import { Box } from '@mui/material';
import React, { Component } from 'react';
import FundOpportunity from '../models/FundOpportunity';
import Investor from '../models/Investor';
import { Palette } from 'Palette';
import { StyledHeading } from './styles/styles';
import StyledSection from './styles/StyledSection';
import FundOpportunityHeaderActions from './fundOpportunityHeader/FundOpportunityHeaderActions';
import FundOpportunityLifecycleSection from './fundOpportunityHeader/FundOpportunityLifecycleSection';
import FundOpportunitySummaryGrid from './fundOpportunityHeader/FundOpportunitySummaryGrid';
import { isNewOpportunityStatus } from './fundOpportunityHeader/fundOpportunityHeaderUtils';

type FundOpportunityHeaderProps = {
  onCreateAppointment: () => void;
  onSendMessage: () => void;
  onShare: () => void;
  printMode?: boolean;
  tone?: keyof typeof Palette;
  fundOpportunity: FundOpportunity;
  investor?: Investor;
  downloadPDF: () => void;
  /** When false, the Download PDF control is hidden (e.g. no static PDF for this opportunity). */
  showDownloadPdf?: boolean;
  advisingFor?: string | null;
};

class FundOpportunityHeader extends Component<FundOpportunityHeaderProps> {
  render() {
    const {
      onCreateAppointment,
      onSendMessage,
      onShare,
      printMode,
      tone = 'default',
      fundOpportunity,
      downloadPDF,
      showDownloadPdf,
      advisingFor,
    } = this.props;

    const isNewOpportunity = isNewOpportunityStatus(fundOpportunity.status);

    return (
      <StyledSection
        tone={tone}
        bottomSpacing={4}
        leftRightSpacing={0}
        noSidePaddingFrom="xs"
        noTopPadding
        additionalClassName="fund-opportunity-header"
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={4}
          flexWrap="wrap"
          gap={2}
        >
          <StyledHeading
            tone={tone}
            noTopPadding
            sx={{
              pt: { xs: '1.875rem', lg: 0 },
              pb: { xs: advisingFor ? 0 : '1.875rem', lg: 0 },
            }}
          >
            {isNewOpportunity && 'New Opportunity: '}
            {fundOpportunity?.summaryTitle || 'Investment Opportunity'}
          </StyledHeading>
          {advisingFor ? (
            <StyledHeading
              headerVariant="subheading"
              noTopPadding
              sx={{
                mt: 0,
                pt: 0,
                pb: { xs: advisingFor ? 0 : '1.875rem', lg: 0 },
              }}
            >
              (for {advisingFor})
            </StyledHeading>
          ) : null}

          {!printMode && (
            <FundOpportunityHeaderActions
              onCreateAppointment={onCreateAppointment}
              onSendMessage={onSendMessage}
              onShare={onShare}
              downloadPDF={downloadPDF}
              showDownloadPdf={showDownloadPdf}
            />
          )}
        </Box>

        <StyledSection tone="tone1" withBorder={!!printMode}>
          <StyledHeading tone="tone1">Opportunity Summary</StyledHeading>
          <FundOpportunitySummaryGrid fundOpportunity={fundOpportunity} printMode={printMode} />
          <FundOpportunityLifecycleSection status={fundOpportunity.status} printMode={printMode} />
        </StyledSection>
      </StyledSection>
    );
  }
}

export default FundOpportunityHeader;
